import { apiJson } from './api'

/**
 * Kullanici tercihleri (`/api/me/settings`).
 *
 * `PUT` KISMI: yalnizca gonderilen alanlar guncelleniyor. Bu yuzden dil
 * kaydetmek icin butun ayar nesnesini once okumak GEREKMIYOR - okuyup geri
 * yazmak, iki sekmenin birbirinin ayarini ezmesi icin acik davetiye
 * olurdu.
 */
export interface UserSettings {
  default_think: string
  system_prompt: string | null
  preferred_model: string
  locale: string
  theme: string | null
}

export async function saveLocale(locale: string): Promise<void> {
  await apiJson<{ status: string }>('/api/me/settings', {
    method: 'PUT',
    body: JSON.stringify({ locale }),
  })
}

export async function saveTheme(theme: string | null): Promise<void> {
  await apiJson<{ status: string }>('/api/me/settings', {
    method: 'PUT',
    body: JSON.stringify({ theme }),
  })
}
